import React from 'react';
import classnames from 'classnames';
import { emit } from './event-emitter';
import Dropdown from './dropdown';
import { OPEN_DROPDOWN } from './const';

// @ts-ignore TS(2322): Type 'null' is not assignable to type 'string'.
function DropdownTrigger({
  // @ts-ignore TS(2322): Type 'null' is not assignable to type 'string'.
  for: labelFor = null,
  arrow = false,
  children = null,
  className = '',
  ...otherProps
}) {
  const triggerClass = classnames(
    'ws-dropdown__trigger',
    {
      'ws-dropdown__trigger-arrow': arrow,
    },
    className
  );

  const onClick = () => {
    Dropdown.dispatchHide();
    emit(OPEN_DROPDOWN, labelFor);
  };

  return (
    <a {...otherProps} {...(labelFor && { onClick })} className={triggerClass}>
      {children}
    </a>
  );
}

export default DropdownTrigger;
